import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import crossIcon from "../../../Assets/images/cross_icon.png";
import styles from "./ConfirmationPop.module.scss";
import { Formik, Form } from "formik";
import LoadingButton from "components/shared/LoadingButton";
import { RequiredFieldAstrick } from "components/Common/Common";
import { DOCUMENT_TYPE_OPTIONS, MIME_TYPES } from "config/constants";
import AppFileUploadField from "components/shared/FormComponents/AppFileUploadField";
import attachDocumentSchema from "./attachDocument.schema";
import { useAttachDocumentMutation } from "store/services/client";
import { successMessageToast } from "helpers/common";


const AddClientDocumentsModal = ({
  onCancel,
  show,
  setShow,
  clientId,
  refetch
}) => {

  const handleClose = () => {
    setShow(false);
  };

  const handlePopup = () => setShow(!show);

  const [attachDocuments, { isLoading }] = useAttachDocumentMutation();

  const handleSubmit = async (values) => {

    try {
      const response = await attachDocuments({ clientId, data: values }).unwrap();

      refetch();
      successMessageToast(response?.message);

      handlePopup()

    } catch (err) {
      console.log("Error uploading attachment", err)
    };
  };


  const handleAttachDocument = (name, value, prevValues = [], setFieldValue) => {
    try {
      const attachment = [{
        attachment_key: value,
        attachment_name: value,
      }]
      setFieldValue("documents", attachment);
    } catch (err) {
      console.error("Failed to attach document", err);
    }
  };

  return (
    <Modal
      show={show}
      className={`${styles.ConfirmationPop} transparentModal common-confirmation-modal modal-v2`}
      onHide={onCancel}
      backdrop="static"
      keyboard={false}
      centered
      size="md"
    >
      <Modal.Body className={`${styles.modalBody}`}>
        <div className="text-center mx-auto">
          {/* Header */}
          <div
            className="section-title d-flex align-items-center justify-content-between"
            style={{ borderBottom: "1px solid #315D99" }}
          >
            <h3 className="mb-0 pb-0 section-title border-bottom-0" style={{ fontSize: "14px" }}>
              ADD DOCUMENT
            </h3>
            <img
              onClick={handleClose}
              width={16}
              height={16}
              src={crossIcon}
              alt="crossIcon"
              style={{ cursor: "pointer" }}
            />
          </div>

          {/* Formik Form */}
          <Formik
            initialValues={{ documents: [], resource_type: '' }}
            validationSchema={attachDocumentSchema}
            onSubmit={handleSubmit}
          >
            {({
              handleSubmit,
              handleChange,
              setFieldValue,
              values,
              errors,
              setFieldTouched,
              touched
            }) => (
              <Form onSubmit={handleSubmit}>
                <Row >
                  <Col md="12" sm="6" className="my-3  text-start  name-input-v2">
                    <label className="form-label themeBlue fw-bold mb-0">
                      Choose a File
                      <RequiredFieldAstrick />
                    </label>
                    <AppFileUploadField
                      name="documents"
                      acl={"private"}
                      allowedTypes={[MIME_TYPES.pdf, MIME_TYPES.docx, MIME_TYPES.doc, MIME_TYPES.images, MIME_TYPES.webp, MIME_TYPES.jpeg, MIME_TYPES.jpg, MIME_TYPES.png, MIME_TYPES.ppt, MIME_TYPES.pptx]}
                      className={`${styles.formControl} readonly-box h-auto`}
                      onChange={(name, value) => {
                        handleAttachDocument(name, value, values?.documents, setFieldValue);
                      }}
                    // accept="application/pdf"
                    />
                  </Col>
                  <Col md="12" sm="6" className=" text-start my-3">
                    <label className="form-label themeBlue fw-bold mb-0">
                      Choose a Tag
                      <RequiredFieldAstrick />
                    </label>

                    <div className="d-flex area-pills flex-wrap gap-2 mt-2">
                      {DOCUMENT_TYPE_OPTIONS.map((tag) => (
                        <Button
                          key={tag}
                          type="button"
                          variant={values?.resource_type == tag?.value ? "primary" : "outline-secondary"}
                          className="rounded-pill px-3 py-1 btn-document"
                          onClick={() => {
                            setFieldTouched('resource_type')
                            if (values?.resource_type == tag?.value) {
                              setFieldValue("resource_type", "");
                            } else {
                              setFieldValue("resource_type", tag?.value);
                            }
                          }}
                        >
                          {tag?.label}
                        </Button>
                      ))}
                    </div>
                    {touched.resource_type && errors?.resource_type ? (
                      <div className="error mt-2">{errors?.resource_type}</div>
                    ) : null}
                    {/* <div class="main-attendance-fields">
                      <div class="inner-attendance-fields">
                        <label class="present-absent">Present
                          <input
                            type="radio"
                            checked={values.attendance == "present"}
                            name="attendance"
                            value={"present"}
                            onChange={handleChange}
                          />
                          <span class="checkmark"></span>
                        </label>
                        <label class="present-absent">Absent
                          <input
                            type="radio"
                            name="attendance"
                            value={"absent"}
                            checked={values.attendance == "absent"}
                            onChange={handleChange}
                          />
                          <span class="checkmark"></span>
                        </label>
                      </div>
                    </div> */}
                  </Col>
                </Row>
                <div className="d-flex justify-content-end mt-4 gap-2">
                  <button
                    type="button"
                    className="proxima-regular blue-discharge-screen-btn-border"
                    onClick={handleClose}
                    disabled={isLoading}
                  >
                    Cancel
                  </button>

                  <LoadingButton
                    type="submit"
                    className="proxima-regular blue-discharge-screen-btn"
                    isLoading={isLoading}
                  >
                    Done
                  </LoadingButton>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddClientDocumentsModal;
